export default __webpack_public_path__ + "static/media/StellaM..337bc9f2.svg";